/* 
As a user I want to be able to edit the data associated with my project
So that I can ensure that the connected to my project is accurate.
*/

//Packages
import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
// import countries from "i18n-iso-countries";
// import enLocale from "i18n-iso-countries/langs/en.json";
//Material UI Components
import {
  Grid,
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
//Components
import NoteContainer from "../../components/NoteContainer";
//API Route
import { Route } from "../../utils/config";
//Context
import { userContext } from "../../Context";

export default function EditProject() {
  //User context
  const { user } = useContext(userContext);
  const [isLoaded, setIsLoaded] = useState(false);

  //Id of project based on url params
  const { id } = useParams();

  //Default dropdown menu data to be filled obtained once
  //system data is loaded
  const [dropdowns, setDropdowns] = useState({
    types: [],
    subTypes: [],
    statuses: [],
    qualities: [],
  });

  //Form data state
  const [form, setForm] = useState({
    id: -1,
    primaryPartnerId: user.partnerId,
    name: "",
    projectTypeId: 100,
    projectSubTypeId: 0,
    address: "",
    radius: 0,
    country: "",
    tags: "",
    region: "",
    postalCode: "",
    benifactorCount: 0,
    yearBuilt: 0,
    builtBy: "",
    latitude: 0,
    longitude: 0,
    projectQualityId: 0,
    projectStatusId: 1,
    overview: "",
    isApproved: true,
    isDeleted: false,
  });

  // const countryObj = countries.getNames("en", { select: "official" });
  // countries.registerLocale(enLocale);
  // const countryArr = Object.entries(countryObj).map(([key, value]) => {
  //   return {
  //     label: value,
  //     value: key,
  //   };
  // });

  //Get dropdown values then project data on render
  useEffect(() => {
    const getData = async () => {
      await getDropdownValues();
      getProject(id);
    };
    getData();
    window.scrollTo(0, 0);
  }, [id]);

  const getProject = (id) => {
    let store = JSON.parse(localStorage.getItem("login"));

    axios
      .get(`${Route}/Projects/GetProject`, {
        params: {
          projectId: id,
        },
        headers: { Authorization: `Bearer ${store.token}` },
      })
      .then((res) => {
        setForm(res.data);
        setIsLoaded(true);
      })
      .catch((err) => {
        throw err;
      });
  };

  //Loads dropdowns for project
  const getDropdownValues = () => {
    axios
      .get(`${Route}/Application/GetSystemData`)
      .then((res) => {
        setDropdowns({
          types: res.data.projectTypeList,
          subTypes: res.data.projectSubTypeList,
          statuses: res.data.projectStatusList,
          qualities: res.data.projectQualityList,
        });
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleSubmit = () => {
    let store = JSON.parse(localStorage.getItem("login"));
    axios
      .post(`${Route}/Projects/SaveProject`, JSON.stringify(form), {
        headers: {
          Authorization: `Bearer ${store.token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleInputChange = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  return (
    <Grid container item xs={10}>
      {isLoaded ? (
        <>
          <Box
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            mb={2}
          >
            <Grid container item justifyContent="center" spacing={3} mt={2}>
              <Grid item xs={12} mb={2}>
                <Typography variant="h5">Edit Project</Typography>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="Project Name"
                  name="name"
                  value={form.name}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="type">Project Type</InputLabel>
                  <Select
                    labelId="type"
                    label="Project Type"
                    value={form.projectTypeId || 0}
                    name="projectTypeId"
                    onChange={(e) => {
                      setForm({
                        ...form,
                        projectTypeId: e.target.value,
                        projectSubTypeId: dropdowns.subTypes.filter(
                          (subtype) => subtype.parentId === e.target.value
                        )[0].id,
                      });
                    }}
                  >
                    {dropdowns.types.map((type) => {
                      return (
                        <MenuItem key={type.id} value={type.id}>
                          {type.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="subtype">Project Subtype</InputLabel>
                  <Select
                    labelId="subtype"
                    label="Project Subtype"
                    value={form.projectSubTypeId || 0}
                    name="projectSubTypeId"
                    onChange={handleInputChange}
                  >
                    <MenuItem value={0}>No Subtype</MenuItem>

                    {dropdowns.subTypes
                      .filter(
                        (subtype) => subtype.parentId === form.projectTypeId
                      )
                      .map((subtype) => {
                        return (
                          <MenuItem key={subtype.id} value={subtype.id}>
                            {subtype.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  fullWidth
                  required
                  label="Address"
                  name="address"
                  value={form.address}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Location Radius (in miles)"
                  name="radius"
                  value={form.radius}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Latitude"
                  name="latitude"
                  value={form.latitude}
                  onChange={handleInputChange}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Longitude"
                  name="longitude"
                  value={form.longitude}
                  onChange={handleInputChange}
                />
              </Grid>

              {/* <Grid item xs={4}>
                <FormControl fullWidth variant="filled">
                  <InputLabel id="type">Continent</InputLabel>
                  <Select
                    value={form.continent}
                    name="continent"
                    onChange={handleInputChange}
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="" disabled>
                      Continent
                    </MenuItem>
                    <MenuItem value="africa">Africa</MenuItem>
                    <MenuItem value="asia">Asia</MenuItem>
                    <MenuItem value="oceana">Oceana</MenuItem>
                    <MenuItem value="south-america">South America</MenuItem>
                    <MenuItem value="north-america">North America</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth variant="filled">
                  <InputLabel id="type">Country</InputLabel>
                  <Select
                    value={form.country}
                    name="country"
                    inputProps={{ "aria-label": "Without label" }}
                    onChange={handleInputChange}
                  >
                    <MenuItem value="" disabled>
                      Select Country
                    </MenuItem>
                    {!!countryArr?.length &&
                      countryArr.map(({ label, value }) => (
                        <MenuItem key={value} value={value}>
                          {label}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  required
                  label="Region"
                  name="region"
                  value={form.region}
                  onChange={handleInputChange}
                />
              </Grid> */}

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Country"
                  name="country"
                  value={form.country}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  required
                  label="Region"
                  name="region"
                  value={form.region}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  required
                  fullWidth
                  label="Postal Code"
                  name="postalCode"
                  value={form.postalCode}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Number of Beneficients"
                  name="benifactorCount"
                  value={form.benifactorCount}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Year Built"
                  name="yearBuilt"
                  value={form.yearBuilt}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="quality">Project Quality</InputLabel>
                  <Select
                    labelId="quality"
                    label="Project Quality"
                    defaultValue={form.projectQualityId || 0}
                    value={form.projectQualityId || 0}
                    name="projectQualityId"
                    onChange={handleInputChange}
                  >
                    <MenuItem value={0}>None</MenuItem>

                    {dropdowns.qualities.map((quality) => {
                      return (
                        <MenuItem key={quality.id} value={quality.id}>
                          {quality.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <InputLabel id="status">Project Status</InputLabel>
                  <Select
                    label="Project Status"
                    labelId="status"
                    defaultValue={form.projectStatusId || 0}
                    value={form.projectStatusId}
                    name="projectStatusId"
                    onChange={handleInputChange}
                  >
                    <MenuItem value={0}>None</MenuItem>

                    {dropdowns.statuses.map((status) => {
                      return (
                        <MenuItem key={status.id} value={status.id}>
                          {status.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Project Overview"
                  name="overview"
                  value={form.overview}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item>
                <Button variant="contained" size="large" type="submit">
                  Save Changes
                </Button>
              </Grid>
            </Grid>
          </Box>

          <NoteContainer projectId={form.id}></NoteContainer>
        </>
      ) : (
        <></>
      )}
    </Grid>
  );
}
